import Flex from "@irati/ui/src/Flex"
import {Card} from "@irati/ui/src/Layout"
import styled from "styled-components"

export const AutomationItemImage = styled.img`
  width: 40px;
`
export const AutomationItemContainer = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.spacing.two};
`
export const MainContent = styled(Flex)`
  display: flex;
  align-items: center;
  gap: ${({theme}) => theme.spacing.oneAndHalf};
  opacity: ${({disabled}) => (disabled ? 0.5 : 1)};
`
